export default __webpack_public_path__ + "static/akinn-f958d65f9eff9df6643ca81d20693499.jpg";